import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { SensorSettings } from "./RadarPanel";
import { rtctApi } from "services/rtctApi";

// Sensor settings (Node Control): the radar's own settings as the node read
// them back - from the radar endpoint, which says when they were reported,
// else the settings endpoint's copy. The blind-zone test and the echo
// profile, which change or probe them, are tools on Radar analysis.
export default function RadarSensorSettings({
  mac,
  settings = null,
  refresh = 0,
}) {
  const [radar, setRadar] = useState(null);
  useEffect(() => {
    if (!mac) return;
    const abort = new AbortController();
    rtctApi
      .radar(mac, abort.signal)
      .then((data) => {
        if (!abort.signal.aborted) setRadar(data);
      })
      .catch(() => {
        // Without the radar endpoint the settings endpoint's copy is shown.
      });
    return () => abort.abort();
  }, [mac, refresh]);
  const cfg = radar?.radar_cfg || settings?.radar_cfg || null;
  const cfgAt = radar?.radar_cfg ? radar.radar_cfg_at : null;
  return (
    <section
      className="field-panel field-sensor"
      aria-labelledby="field-sensor-title"
    >
      <div className="field-panel-head">
        <div>
          <h2 id="field-sensor-title">Sensor settings</h2>
          <p>The radar's own settings, as the node read them back</p>
        </div>
        <Link className="field-button" to="/radar-analysis#radar-tools-title">
          Blind-zone test and echo profile{" "}
          <ArrowRight size={14} aria-hidden="true" />
        </Link>
      </div>
      <div className="field-panel-body">
        <SensorSettings cfg={cfg} cfgAt={cfgAt} id="field-sensor-facts" />
      </div>
    </section>
  );
}
